import { endOfMonth, endOfWeek, format, startOfMonth, startOfQuarter, startOfWeek, startOfYear, sub } from 'date-fns';

const dateColumns = {
  'All Time': {
    type: 'date',
    dateType: 'relative',
    fromFn: () => '1970-01-01',
    toFn: (date) => date,
  },
  'M-13': {
    type: 'date',
    dateType: 'relative',
    fromFn: (date) => format(startOfMonth(sub(new Date(date), { months: 13 }), { weekStartsOn: 1 }), 'yyyy-MM-dd'),
    toFn: (date) => format(endOfMonth(sub(new Date(date), { months: 13 }), { weekStartsOn: 1 }), 'yyyy-MM-dd'),
  },
  'M-12': {
    type: 'date',
    dateType: 'relative',
    fromFn: (date) => format(startOfMonth(sub(new Date(date), { months: 12 }), { weekStartsOn: 1 }), 'yyyy-MM-dd'),
    toFn: (date) => format(endOfMonth(sub(new Date(date), { months: 12 }), { weekStartsOn: 1 }), 'yyyy-MM-dd'),
  },
  'M-11': {
    type: 'date',
    dateType: 'relative',
    fromFn: (date) => format(startOfMonth(sub(new Date(date), { months: 11 }), { weekStartsOn: 1 }), 'yyyy-MM-dd'),
    toFn: (date) => format(endOfMonth(sub(new Date(date), { months: 11 }), { weekStartsOn: 1 }), 'yyyy-MM-dd'),
  },
  'M-10': {
    type: 'date',
    dateType: 'relative',
    fromFn: (date) => format(startOfMonth(sub(new Date(date), { months: 10 }), { weekStartsOn: 1 }), 'yyyy-MM-dd'),
    toFn: (date) => format(endOfMonth(sub(new Date(date), { months: 10 }), { weekStartsOn: 1 }), 'yyyy-MM-dd'),
  },
  'M-9': {
    type: 'date',
    dateType: 'relative',
    fromFn: (date) => format(startOfMonth(sub(new Date(date), { months: 9 }), { weekStartsOn: 1 }), 'yyyy-MM-dd'),
    toFn: (date) => format(endOfMonth(sub(new Date(date), { months: 9 }), { weekStartsOn: 1 }), 'yyyy-MM-dd'),
  },
  'M-8': {
    type: 'date',
    dateType: 'relative',
    fromFn: (date) => format(startOfMonth(sub(new Date(date), { months: 8 }), { weekStartsOn: 1 }), 'yyyy-MM-dd'),
    toFn: (date) => format(endOfMonth(sub(new Date(date), { months: 8 }), { weekStartsOn: 1 }), 'yyyy-MM-dd'),
  },
  'M-7': {
    type: 'date',
    dateType: 'relative',
    fromFn: (date) => format(startOfMonth(sub(new Date(date), { months: 7 }), { weekStartsOn: 1 }), 'yyyy-MM-dd'),
    toFn: (date) => format(endOfMonth(sub(new Date(date), { months: 7 }), { weekStartsOn: 1 }), 'yyyy-MM-dd'),
  },
  'M-6': {
    type: 'date',
    dateType: 'relative',
    fromFn: (date) => format(startOfMonth(sub(new Date(date), { months: 6 }), { weekStartsOn: 1 }), 'yyyy-MM-dd'),
    toFn: (date) => format(endOfMonth(sub(new Date(date), { months: 6 }), { weekStartsOn: 1 }), 'yyyy-MM-dd'),
  },
  'M-5': {
    type: 'date',
    dateType: 'relative',
    fromFn: (date) => format(startOfMonth(sub(new Date(date), { months: 5 }), { weekStartsOn: 1 }), 'yyyy-MM-dd'),
    toFn: (date) => format(endOfMonth(sub(new Date(date), { months: 5 }), { weekStartsOn: 1 }), 'yyyy-MM-dd'),
  },
  'M-4': {
    type: 'date',
    dateType: 'relative',
    fromFn: (date) => format(startOfMonth(sub(new Date(date), { months: 4 }), { weekStartsOn: 1 }), 'yyyy-MM-dd'),
    toFn: (date) => format(endOfMonth(sub(new Date(date), { months: 4 }), { weekStartsOn: 1 }), 'yyyy-MM-dd'),
  },
  'M-3': {
    type: 'date',
    dateType: 'relative',
    fromFn: (date) => format(startOfMonth(sub(new Date(date), { months: 3 }), { weekStartsOn: 1 }), 'yyyy-MM-dd'),
    toFn: (date) => format(endOfMonth(sub(new Date(date), { months: 3 }), { weekStartsOn: 1 }), 'yyyy-MM-dd'),
  },
  'M-2': {
    type: 'date',
    dateType: 'relative',
    fromFn: (date) => format(startOfMonth(sub(new Date(date), { months: 2 }), { weekStartsOn: 1 }), 'yyyy-MM-dd'),
    toFn: (date) => format(endOfMonth(sub(new Date(date), { months: 2 }), { weekStartsOn: 1 }), 'yyyy-MM-dd'),
  },
  'M-1': {
    type: 'date',
    dateType: 'relative',
    fromFn: (date) => format(startOfMonth(sub(new Date(date), { months: 1 }), { weekStartsOn: 1 }), 'yyyy-MM-dd'),
    toFn: (date) => format(endOfMonth(sub(new Date(date), { months: 1 }), { weekStartsOn: 1 }), 'yyyy-MM-dd'),
  },
  L3M: {
    type: 'date',
    dateType: 'relative',
    fromFn: (date) => format(startOfMonth(sub(new Date(date), { months: 2 }), { weekStartsOn: 1 }), 'yyyy-MM-dd'),
    // toFn: (date) => format(endOfMonth(sub(new Date(date), { months: 1 }), { weekStartsOn: 1 }), 'yyyy-MM-dd'),
    toFn: (date) => date,
  },
  L2M: {
    type: 'date',
    dateType: 'relative',
    fromFn: (date) => format(startOfMonth(sub(new Date(date), { months: 1 }), { weekStartsOn: 1 }), 'yyyy-MM-dd'),
    // toFn: (date) => format(endOfMonth(sub(new Date(date), { months: 1 }), { weekStartsOn: 1 }), 'yyyy-MM-dd'),
    toFn: (date) => date,
  },
  'W-4': {
    type: 'date',
    dateType: 'relative',
    fromFn: (date) => format(startOfWeek(sub(new Date(date), { weeks: 4 }), { weekStartsOn: 1 }), 'yyyy-MM-dd'),
    toFn: (date) => format(endOfWeek(sub(new Date(date), { weeks: 4 }), { weekStartsOn: 1 }), 'yyyy-MM-dd'),
  },
  'W-3': {
    type: 'date',
    dateType: 'relative',
    fromFn: (date) => format(startOfWeek(sub(new Date(date), { weeks: 3 }), { weekStartsOn: 1 }), 'yyyy-MM-dd'),
    toFn: (date) => format(endOfWeek(sub(new Date(date), { weeks: 3 }), { weekStartsOn: 1 }), 'yyyy-MM-dd'),
  },
  'W-2': {
    type: 'date',
    dateType: 'relative',
    fromFn: (date) => format(startOfWeek(sub(new Date(date), { weeks: 2 }), { weekStartsOn: 1 }), 'yyyy-MM-dd'),
    toFn: (date) => format(endOfWeek(sub(new Date(date), { weeks: 2 }), { weekStartsOn: 1 }), 'yyyy-MM-dd'),
  },
  'W-1': {
    type: 'date',
    dateType: 'relative',
    fromFn: (date) => format(startOfWeek(sub(new Date(date), { weeks: 1 }), { weekStartsOn: 1 }), 'yyyy-MM-dd'),
    toFn: (date) => format(endOfWeek(sub(new Date(date), { weeks: 1 }), { weekStartsOn: 1 }), 'yyyy-MM-dd'),
  },
  L4W: {
    type: 'date',
    dateType: 'relative',
    fromFn: (date) => format(startOfWeek(sub(new Date(date), { weeks: 3 }), { weekStartsOn: 1 }), 'yyyy-MM-dd'),
    // toFn: (date) => format(endOfWeek(sub(new Date(date), { weeks: 1 }), { weekStartsOn: 1 }), 'yyyy-MM-dd'),
    toFn: (date) => date,
  },
  L3W: {
    type: 'date',
    dateType: 'relative',
    fromFn: (date) => format(startOfWeek(sub(new Date(date), { weeks: 2 }), { weekStartsOn: 1 }), 'yyyy-MM-dd'),
    // toFn: (date) => format(endOfWeek(sub(new Date(date), { weeks: 1 }), { weekStartsOn: 1 }), 'yyyy-MM-dd'),
    toFn: (date) => date,
  },
  L2W: {
    type: 'date',
    dateType: 'relative',
    fromFn: (date) => format(startOfWeek(sub(new Date(date), { weeks: 1 }), { weekStartsOn: 1 }), 'yyyy-MM-dd'),
    // toFn: (date) => format(endOfWeek(sub(new Date(date), { weeks: 1 }), { weekStartsOn: 1 }), 'yyyy-MM-dd'),
    toFn: (date) => date,
  },
  L6D: {
    type: 'date',
    dateType: 'relative',
    fromFn: (date) => format(sub(new Date(date), { days: 5 }), 'yyyy-MM-dd'),
    toFn: (date) => date,
  },
  L3D: {
    type: 'date',
    dateType: 'relative',
    fromFn: (date) => format(sub(new Date(date), { days: 2 }), 'yyyy-MM-dd'),
    toFn: (date) => date,
  },
  L2D: {
    type: 'date',
    dateType: 'relative',
    fromFn: (date) => format(sub(new Date(date), { days: 1 }), 'yyyy-MM-dd'),
    toFn: (date) => date,
  },
  'D-1': {
    type: 'date',
    dateType: 'relative',
    fromFn: (date) => format(sub(new Date(date), { days: 1 }), 'yyyy-MM-dd'),
    toFn: (date) => format(sub(new Date(date), { days: 1 }), 'yyyy-MM-dd'),
  },
  YTD: {
    type: 'date',
    dateType: 'relative',
    fromFn: (date) => format(startOfYear(new Date(date)), 'yyyy-MM-dd'),
    toFn: (date) => date,
  },
  QTD: {
    type: 'date',
    dateType: 'relative',
    fromFn: (date) => format(startOfQuarter(new Date(date)), 'yyyy-MM-dd'),
    toFn: (date) => date,
  },
  MTD: {
    type: 'date',
    dateType: 'relative',
    fromFn: (date) => format(startOfMonth(new Date(date)), 'yyyy-MM-dd'),
    toFn: (date) => date,
  },
  WTD: {
    type: 'date',
    dateType: 'relative',
    fromFn: (date) => format(startOfWeek(new Date(date), { weekStartsOn: 1 }), 'yyyy-MM-dd'),
    toFn: (date) => date,
  },
  Today: {
    type: 'date',
    dateType: 'relative',
    fromFn: (date) => date,
    toFn: (date) => date,
  },
};

export default dateColumns;
